export default __webpack_public_path__ + "static/media/Supercharge-Your-Career.806966af.png";